import React, { useEffect, useState } from "react";
import Layout from "../../layout";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactGA from "react-ga4";
import { useForm } from "react-hook-form";
import validation from "./validation";
import { Imagesdata } from "../../assets/images/imageData";
import { InputField } from "../../components/InputField/InputField";
import { ErrorMessage } from "@hookform/error-message";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Services from "../../API/services";
import { useLocation } from "react-router-dom";
import InputComponent from "./InputComponent";
import moment from "moment";
import {
  CheckPaymentMode,
  daysDiffernce,
  showDate,
  showPercentage,
  showPrice,
  taxOnly,
} from "../../utils/utils";
import { Margin, usePDF } from "react-to-pdf";
import {
  getBanquetBookingServices,
  getBanquetBookingVenue,
} from "API/services/newServices";

const MealPlanText = ["EP", "CP", "AP", "MAP"];

const Invoice = () => {
  const [editInvoice, setEditInvoice] = useState(false);
  const { AlertIcon } = Imagesdata || {};
  const { userDetail } = useSelector(authenticationSeletor);
  const { state } = useLocation();
  const [edit, setEdit] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [categoryName, setCategoryName] = useState("");
  const [services, setServices] = useState([]);
  const [venues, setVenues] = useState([]);
  const [paymentMode, setPaymentMode] = useState(state?.paymentMode);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([])
  const [stateList, setStateList] = useState([]);
  const [showBillTo, setShowBillTo] = useState('');
  const [selectState, setSelectState] = useState(0)

  console.log(state)

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const { toPDF, targetRef } = usePDF({
    method: "open",
    filename: "roomInvoice.pdf",
    page: { margin: Margin.NONE, format: "letter" },
    canvas: {
      mimeType: "image/png",
      qualityRatio: 10,
    },
    overrides: {
      pdf: {
        compress: false,
      },
      canvas: {
        useCORS: true,
      },
    },
  });

  const getServices = async (id) => {
    const res = await getBanquetBookingServices(id);
    if (res) setServices(res);
  };
  const getVenueItem = async (id) => {
    const res = await getBanquetBookingVenue(id);
    if (res) setVenues(res);
  };

  const getState = async () => {
    try {
      const state = await Services.globalService.getAllState();
      if (state.status === 200) {
        setStateList(state.data.data);
      }
    } catch (error) { }
  };

  const fetchCities = async () => {
    try {
      const res = await Services.globalService.getCities()
      if (res.status === 200) {
        setCities(res?.data?.data)
      }
    }
    catch { }
  }

  useEffect(() => {
    getState()
    fetchCities()
  }, [])

  useEffect(() => {
    if (state?.banquetData) {
      setValue("addre", state?.address);
      setValue("guestGst", state?.gst);
      setValue("cName", state?.companyName);
      setValue("cAddre", state?.address);
      getServices(state?.banquetBookingId);
      getVenueItem(state?.banquetBookingId);
    }

    setValue("date");
  }, []);

  const getInvoiceDetails = async () => {
    try {
      setLoading(true);
      const res = await Services.property.getInvoiceData(
        `?property_id=${userDetail?.propertyId}`
      );
      if (res.status === 200) {
        setLoading(false);
        if (res?.data?.data?.[0] == null) return;
        setInvoiceData(res?.data?.data[0]);
        if (Object.keys(res?.data?.data[0]).length > 0) {
          setValue("gstIn", res?.data?.data[0]?.gstNumber);
          setValue("gstCode", res?.data?.data[0]?.gstNumber);
          setEdit(true);
        }
      }
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setLoading(false);
    }
  };

  // const getData = async () => {
  //   if (state?.banquetData) {
  //     return;
  //   }
  //   const rooms = await Services.globalService.getRoomByPropertyIdService(
  //     userDetail?.propertyId
  //   );
  //   if (rooms.status === 200) {
  //     setRooms(rooms?.data?.data);
  //   }
  // };


  const getCategory = async () => {
    if (state?.banquetData) {
      return;
    }
    const res = await Services.property.getRoomCategoryService(
      userDetail?.propertyId
    );
    if (res.status === 200) {
      setCategoryName(
        res.data.data.find((i) => i.id == state.propertyRoomsCategoryId).name
      );
    }
  };

  const editHandler = () => {
    setEditInvoice(true);
    if (edit) {
      setValue("propertyName", invoiceData?.name);
      setValue("mobile", invoiceData?.phone);
      setValue("email", invoiceData?.email);
      setValue("gst", invoiceData?.gstNumber);
      setValue("mobileQuery", invoiceData?.queryContactNumber);
      setValue("address", invoiceData?.address);
      setValue("propertyContent", invoiceData?.content);
    }
  };



  const onSubmit = async ({
    address,
    email,
    gst,
    logo,
    mobile,
    mobileQuery,
    propertyContent,
    propertyName,
  }) => {
    var bodyData = new FormData();
    bodyData.append("property_id", userDetail?.propertyId);
    bodyData.append("logo", logo[0]);
    bodyData.append("name", propertyName);
    bodyData.append("address", address);
    bodyData.append("phone", mobile);
    bodyData.append("email", email);
    bodyData.append("gst_number", gst);
    bodyData.append("content", propertyContent);
    // bodyData.append("query_contact_number", mobileQuery);
    // if (!edit) {
    //   if (logo.length <= 0 || logo[0].type !== "image/png") {
    //     setImgError("Please Select Property Logo only png formate");
    //     return;
    //   }
    // }
    try {
      let res = {};
      let message = "";
      if (edit) {
        res = await Services.property.reEditInvoiceData(
          bodyData,
          invoiceData?.id
        );
        message = "Invoice Details Successfully Updated!";
      } else {
        res = await Services.property.editInvoiceData(bodyData);
        message = "Invoice Details Successfully Submitted!";
      }
      if (res.status === 200) {
        toast.success(message, {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        getInvoiceDetails()
        setEditInvoice(false);
      }
      reset();
    } catch (error) { }
  };

  useEffect(() => {
    if (state) {
      getCategory();
    }
    ReactGA.send({ hitType: "pageview", page: "invoice_details" });
    getInvoiceDetails();
    setValue("gstCode", invoiceData?.gstNumber);
    setValue("gstIn", invoiceData?.gstNumber);
  }, []);
  const totalDays = daysDiffernce(
    state?.fromDate,
    state?.toDate
  );

  const totalNights = state.fromDate == state.toDate ? 1 : totalDays

  const totalAmount = (state?.bookingAmout)
  const taxableAmount = (totalAmount / 1.12)
  const gst = totalAmount - taxableAmount
  const sgst = gst / 2;
  const cgst = gst / 2;
  const igst = gst;
  const roomRate = taxableAmount / (state?.noOfRooms * totalNights)

  let totalCollectedPayment = state?.Payments?.reduce((acc, curr) => acc + Number(curr.paymentAmount), 0)

  const content = invoiceData?.content?.split(".");

  return (
    <Layout
      title="Invoice"
      openHandler={editHandler}
      buttonTitle="Edit Invoice"
      // extraButton="Download PDF"
      extraBtnHandler={toPDF}
      withoutContainer
    >

      <div className="text-center mb-2">
        <div className="flex justify-content-center">
          <div className="form-group mr-4">
            <label className="mr-1">Bill To</label>
            <select style={{ fontSize: '12px', padding: '2px 4px' }} onChange={(e) => setShowBillTo(e.target.value)}>
              <option value="Guest">Guest</option>
              <option value="Company">Company</option>
            </select>
          </div>
          <div className="form-group mr-4">
            <label className="mr-1">State</label>
            <select style={{ fontSize: '12px', padding: '2px 4px' }} onChange={(e) => setSelectState(e.target.value)}>
              <option value="">Select State</option>
              {
                stateList?.map((state) => <option key={state?.id} value={state?.id}>{state?.name}</option>)
              }
            </select>
          </div>
        </div>

      </div>
      <div className="printBox borders" ref={targetRef} style={{ width: '800px', backgroundColor: '#fff', margin: '0 auto' }}>
        <table className="printInvoice">
          <tbody>
            <tr>
              <td colSpan={2} className="text-center">
                <h3>Invoice</h3>
                <h4 style={{ fontSize: '18px' }}>{invoiceData?.name ? invoiceData?.name : invoiceData?.PropertyMaster?.name}</h4>
                <p>GSTIN No : {invoiceData?.gstNumber ?? "N/A"}</p>
                <p style={{ paddingTop: '10px', paddingBottom: '5px' }}>{invoiceData?.address ?? "Your Property Address"}</p>
                <p style={{ paddingBottom: '20px' }}>Phone: {invoiceData?.phone ?? "Your Phone Number"}, Email: {invoiceData?.email ?? "Your Email Address"}</p>
              </td>
            </tr>
            <tr>
              <td className="one">
                <table>
                  <tr>
                    <th>Folio No. / ResNo</th>
                    <td>: {state.bookingCode}
                    </td>
                  </tr>
                  <tr>
                    <th>Invoice No</th>
                    <td>:  <input
                          type="text"
                          value={state?.id}
                          placeholder="Enter Company Address"
                          style={{ outline: 'none', border: 'none', }} /></td>
                  </tr>
                  <tr>
                    <th>Guest Name</th>
                    <td>{': '}
                      {state?.User?.name || state?.otherPersonName}
                    </td>
                  </tr>
                  <tr>
                    <th>Bill To</th>
                    <td>{': '}
                      {/* {state?.otherPersonName ??
                        state?.User?.name ??
                        state?.customerName} */}

                      {
                        showBillTo == "Company" ? (
                        state?.User?.company || <input
                          type="text"
                          placeholder="Enter Company Name"
                          style={{ outline: 'none', border: 'none', }} />
                        ) : state?.User?.name || state?.otherPersonName
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>Bill To Address</th>
                    <td> {': '}
                      {
                        showBillTo == "Company" ? (
                          state?.User?.address || 
                        <input
                          type="text"
                          placeholder="Enter Company Address"
                          style={{ outline: 'none', border: 'none', }} />
                        ) : <input
                          type="text"
                          placeholder="Enter Your Address"
                          style={{ outline: 'none', border: 'none', }} />
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>State</th>
                    <td>: {!showBillTo && 'N/A'} {stateList.find((data) => data.id === Number(selectState))?.name}</td>
                  </tr>
                  <tr>
                    <th>Bill To GSTIN No</th>
                    <td>: 
                      {
                        showBillTo == "Company" ? (
                          state?.User?.gst || 
                        <input
                          type="text"
                          placeholder="Enter Company Address"
                          style={{ outline: 'none', border: 'none', }} />
                        ) : ' -------'
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>Source Of Supply</th>
                    <td>: {state?.PropertyMaster?.cityName}</td>
                    {/* <td>: {state?.source}</td> */}
                  </tr>
                </table>
              </td>
              <td className="one">
                <table>
                  <tr>
                    <th>G.R. Card No</th>
                    <td>: {state?.bookingCode}
                    </td>
                  </tr>
                  <tr>
                    <th>Date of Invoice</th>
                    <td>: {moment(new Date()).format("D-MM-YYYY ")}</td>
                  </tr>
                  <tr>
                    <th>Room</th>
                    <td>{': '}
                      {(state?.banquetData
                        ? venues?.session
                        : categoryName) ?? "N/A"} /
                      {(state?.banquetData
                        ? venues?.session
                        : state?.assignRoomNo) ?? "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <th>No of Person</th>
                    <td>
                      : {state?.banquetData
                        ? state?.numberOfGuests ?? "0"
                        : `${state?.adults}`} (A) / 0 (C)
                    </td>
                  </tr>
                  <tr>
                    <th>Rate Type</th>
                    <td>: {MealPlanText[state?.breakFast]}</td>
                  </tr>
                  <tr>
                    <th>No of Nights</th>
                    <td>: {' '}
                      {
                        totalNights

                      }
                    </td>
                  </tr>
                  <tr>
                    <th>Date of Arrival</th>
                    <td>{': '}
                      {moment(
                        state?.fromDate
                          ? state?.fromDate
                          : ''
                      ).format("DD-MM-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <th>Date of Departure</th>
                    <td> {': '}
                      {moment(
                        state?.toDate
                          ? state?.toDate
                          : ''
                      ).format("DD-MM-YYYY")}
                      {/* {
                        state?.toDate
                          ? moment(state?.checkOutDateTime).format(
                            "D-M-Y, HH:MM"
                          )
                          : "Yet to Check-Out"


                      } */}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td className="two" colSpan={2}>
                <table>
                  <tr>
                    <th style={{ padding: '2px', margin: '0px' }}>Sr No</th>
                    <th style={{ padding: '2px', margin: '0px' }}>Particular</th>
                    <th style={{ padding: '2px', margin: '0px' }}>HSN/SAC</th>
                    <th style={{ padding: '2px', margin: '0px' }}>Rooms</th>
                    <th style={{ padding: '2px', margin: '0px' }}>Rate</th>
                    <th style={{ padding: '2px', margin: '0px' }}>Total</th>
                    <th style={{ padding: '2px', margin: '0px' }}>Discount</th>
                    <th style={{ padding: '2px', margin: '0px' }}>Taxable</th>
                    <th style={{ padding: '2px', margin: '0px' }}>SGST</th>
                    <th style={{ padding: '2px', margin: '0px' }}>CGST</th>
                    <th style={{ padding: '2px', margin: '0px' }}>IGST</th>
                    {/* <th style={{ padding: '5px', margin: '0px' }}>CESS</th> */}
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Room Charges</td>
                    <td>996311</td>
                    <td>
                      {state?.noOfRooms}
                    </td>
                    <td>{showPrice(roomRate)}</td>
                    <td>{showPrice(taxableAmount)}</td>
                    <td>{state?.discountAmount}</td>

                    <td>{showPrice(taxableAmount)}</td>
                    <td>
                      {
                        selectState && state.PropertyMaster.stateId == selectState ? showPrice(sgst) : showPrice(0)
                      }
                    </td>
                    <td>
                      {
                        selectState && state.PropertyMaster.stateId == selectState ? showPrice(cgst) : showPrice(0)
                      }
                    </td>
                    <td>
                      {
                        selectState && state.PropertyMaster.stateId != selectState ? showPrice(Math.floor(igst)) : showPrice(0)
                      }
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td className="three">
                <h4>Total Payable Amoun</h4>
                <p style={{ marginBottom: '50px' }}>One thousand ninety two</p>
                <table>
                  <tr>
                    <th>Payment Date</th>
                    <th>Description</th>
                    <th>Amount</th>
                  </tr>
                  {
                    state?.Payments?.map((item)=>{
                      return(
                        <tr key={item?.id}>
                          <td>{new Date(item?.paymentDate).toLocaleDateString('en-IN',{
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                          })}</td>
                          <td>{CheckPaymentMode(item?.paymentMode)}</td>
                          <td>{item?.paymentAmount}</td>
                        </tr>
                      )
                    })
                  }
                  <tr>
                    <td colSpan={3} className="text-right"><span>Total</span> {showPrice(totalCollectedPayment)}</td>
                  </tr>
                </table>
                <div style={{ height: '100px' }}></div>
                <table>
                  <tr>
                    <th>Tax Details</th>
                    <th>Taxable Amount</th>
                    <th>Tax Amount</th>
                  </tr>
                  <tr>
                    <td>SGST @ 6.00%</td>
                    <td>{showPrice(taxableAmount)}</td>
                    <td>
                      {
                        selectState && state.PropertyMaster.stateId == selectState ? showPrice(sgst) : showPrice(0)
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>CGST @ 6.00%</td>
                    <td>{showPrice(taxableAmount)}</td>
                    <td>
                      {
                        selectState && state.PropertyMaster.stateId == selectState ? showPrice(cgst) : showPrice(0)
                      }
                    </td>
                  </tr>
                </table>
              </td>
              <td className="four">
                <table style={{ marginTop: "-1px" }}>
                  <tr>
                    <th>Total Charges(Rs) :</th>
                    <td>0.00</td>
                  </tr>
                  <tr>
                    <th>Total Discount(Rs) :</th>
                    <td>{state?.discountAmount == 0 ? '0.00' : showPrice(state?.discountAmount)}</td>
                  </tr>
                  <tr>
                    <th>Total SGST(Rs) :</th>
                    <td>
                      {
                        selectState && state.PropertyMaster.stateId == selectState ? showPrice(sgst) : showPrice(0)
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>Total CGST(Rs) :</th>
                    <td>
                      {
                        selectState && state.PropertyMaster.stateId == selectState ? showPrice(cgst) : showPrice(0)
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>Total IGST(Rs) :</th>
                    <td>
                      {
                        selectState && state.PropertyMaster.stateId != selectState ? showPrice(Math.floor(igst)) : showPrice(0)
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>Total Other Tax(Rs) :</th>
                    <td>0.00</td>
                  </tr>
                  <tr>
                    <th>Total Balance Transfer(Rs) :</th>
                    <td>0.00</td>
                  </tr>
                  <tr>
                    <th>Total(Rs) :</th>
                    <td>
                      {showPrice(state?.bookingAmout)}
                    </td>
                  </tr>
                  <tr>
                    <th>Flat Discount(Rs) :</th>
                    <td>0.00</td>
                  </tr>
                  <tr>
                    <th>Adjustment(Rs) :</th>
                    <td>0.00</td>
                  </tr>
                  <tr>
                    <th>Total Payable(Rs) :</th>
                    <td>
                      {showPrice(state?.bookingAmout)}
                    </td>
                  </tr>
                  <tr>
                    <th>Total Payment(Rs) :</th>
                    <td>
                      {showPrice(totalCollectedPayment)}
                    </td>
                  </tr>
                  <tr>
                    <th>Balance(Rs) :</th>
                    <td>{showPrice(state?.bookingAmout - totalCollectedPayment)}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <div style={{ fontWeight: '600',  marginTop: '10px', marginBottom: '10px' }}>Remark :</div>
                <ul style={{fontSize: '10px'}}>
                  <li style={{fontSize: '10px'}}>Check Out Time 11:00 Noon</li>
                  <li style={{fontSize: '10px'}}>All Disputes subject to {state?.PropertyMaster?.cityName} Jurisdiction.</li>
                  <li style={{fontSize: '10px'}}>I agree that I am liable for the full payment of this bill in the event it is not paid by Company/Organization or Person indicated.</li>
                  <li style={{fontSize: '10px'}}>I have collected my Luggage/Ariticies/Belonging at the time of Check out any suggestion/query then contact</li>
                  <li style={{fontSize: '10px'}}>Please keep your keys at reception while leaving the hotel.</li>
                  <li style={{fontSize: '10px'}}>Feel free to reception for any service.</li>
                  </ul>
              </td>
            </tr>
            <tr>
              <td className="five" style={{ borderTop: 'solid 1px #000', paddingTop: '12px' }}>
                <table>
                  <tr>
                    <th>This Folio is in</th>
                    <td>: {state?.bookingCode}</td>
                  </tr>
                  <tr>
                    <th>Reception (C/I)</th>
                    <td>: {userDetail?.name}</td>
                  </tr>
                  <tr>
                    <th>Cashier (C/O)</th>
                    <td>: {userDetail?.name}</td>
                  </tr>
                  <tr>
                    <th>Date</th>
                    <td>: {
                      state?.checkOutDateTime
                        ? moment(state?.checkOutDateTime).format(
                          "DD-MM-YYYY, HH:MM"
                        )
                        : "Yet to Check-Out"


                    }</td>
                  </tr>
                  <tr>
                    <th>Page</th>
                    <td>: Page 1 of 1</td>
                  </tr>
                </table>
              </td>
              <td style={{ borderTop: 'solid 1px #000', paddingTop: '12px' }}>
                {/* <p><span style={{ fontWeight: '700' }}>Folio NOTICE</span></p>
                <p><span style={{ fontWeight: '700' }}>Folio NOTICE</span></p> */}
              </td>
            </tr>
            <tr>
              <td className="text-center" style={{ borderTop: 'solid 1px #000', paddingTop: '10px' }}>
                (Guest Signature)
              </td>
            </tr>
          </tbody>
        </table>
      </div>



      <Modal
        backdrop="static"
        show={editInvoice}
        onHide={() => {
          setEditInvoice(false);
          reset();
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="popup-form onboardForm"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Container>
              <Row>
                <h6 className="text-dark">Invoice Header :</h6>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="propertyName"
                    text="Property Name"
                    type="text"
                    placeholder="Enter Property Name"
                    field={"propertyName"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.propertyName?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage
                          errors={errors}
                          notnull
                          name={"propertyName"}
                        />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="mobile"
                    text="Property Mobile Number"
                    type="text"
                    max={10}
                    placeholder="Enter Property Mobile Number"
                    field={"mobile"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.mobile?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} notnull name={"mobile"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="email"
                    text="Property Email ID"
                    type="text"
                    placeholder="Enter Property Email ID"
                    field={"email"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.email?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} notnull name={"email"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="gst"
                    text="Property GST Number"
                    type="text"
                    placeholder="Enter Property GST Number"
                    field={"gst"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.gst?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} notnull name={"gst"} />
                      </span>
                    </div>
                  )}
                </Col>

                <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="logo"
                    text="Property Logo"
                    type="file"
                    placeholder="Enter Property Logo"
                    field={"logo"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                </Col>
                <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="address"
                    text="Property Address"
                    type="textArea"
                    placeholder="Enter Property Address"
                    field={"address"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.address?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>{errors?.address?.message}</span>
                    </div>
                  )}
                </Col>
                {/* <h6 className="text-dark">Invoice Footer :</h6> */}
                {/* <Col xs={6} className="form-group">
                  <InputField
                    htmlFor="mobileQuery"
                    text="Property Mobile Number"
                    type="text"
                    max={10}
                    placeholder="Enter Property Mobile Number"
                    field={"mobileQuery"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.mobileQuery?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage
                          errors={errors}
                          notnull
                          name={"mobileQuery"}
                        />
                      </span>
                    </div>
                  )}
                </Col> */}
                {/* <Col xs={12} className="form-group">
                  <InputField
                    htmlFor="propertyContent"
                    text="Property Content"
                    type="textArea"
                    placeholder="Enter Property Content"
                    field={"propertyContent"}
                    register={register}
                    errors={errors}
                    notnull
                  />
                  {errors?.propertyContent?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>{errors?.propertyContent?.message}</span>
                    </div>
                  )}
                </Col> */}
                <Row className="justify-content-center">
                  <Col xs={1}>
                    <Button type="submit">Submit</Button>
                  </Col>
                </Row>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default Invoice;
